import React, { useContext, useState } from 'react'
import { BankUserContext } from '../../../bankUserContext';
import editIcon from '../../../images/MessageCenter/edit.svg';
import backBtn from '../../../images/backArrow.svg';
import sideOutArrowIcon from '../../../images/side-out-arrow.svg';
import slideBackIcon from "../../../images/slide-back.svg"
import moment from 'moment';
import CaseDetailsStatus from './CaseDetailsStatus';
import { CaseStatusEnum, ICaseStatusModel } from '../../../models/Cases/CaseDetailsModel';
import { valueEllipsis } from '../../../utils/GeneralUtils';
import { transformUTCDateWithoutTime } from '../../../utils/dateUtil';
import { useNavigate } from 'react-router-dom';
import EllipsisTooltip from '../../../utils/EllipsisTooltip';

interface ICaseMasterDetailsProps {
  caseDetails: any;
  disableforsuperuser: boolean;
  expand: boolean;
  setExpand: (value: boolean) => void;
  caseSatusDetails: ICaseStatusModel[] | [];
  createLeadModal?: () => void
  getCaseStatusChangeHandler?: (caseId: string) => void;
}

const CaseMasterDetails = (props: ICaseMasterDetailsProps) => {
  const { expand, setExpand, caseSatusDetails, caseDetails, createLeadModal, getCaseStatusChangeHandler } = props;
  // const roles = new RolesAuthentication();
  const context = useContext(BankUserContext);
  // console.log("context", context.bankuserDetails?.organization?.orgId)
  const [redirect, setRedirect] = useState(false);
  const navigate = useNavigate();

  const toggleShowEditLeadModal = () => {
    createLeadModal && createLeadModal();
  }

  const getDaysRemaining = (value: number) => {
    if (value) {
      if (value < 0) return Math.abs(value);
      else return value;
    } else return '--';
  }
  const statusChangeHandler = (caseId: string) => {
    getCaseStatusChangeHandler && getCaseStatusChangeHandler(caseId);
  }

  return (
    <div className="leadmainContainer d-flex w-100">
      <button className="backButton" onClick={() => navigate(-1)}>
        <img 
        src={backBtn}
         alt="back" />
      </button>
      <div className="leadmaincard">
        <div className="leadHeading">
          <div className="headingdata flex-1">
            <div className="leadmainheadingdetails">
              <h4 className="leadheadCompanyname">
                {valueEllipsis(props.caseDetails?.title, 20) || '--'}
              </h4>
              <p className="leadheadType">
              <EllipsisTooltip text={props?.caseDetails?.caseType === "General" ?
                  props?.caseDetails?.caseType :
                  (props.caseDetails?.companyName || '--')
                } maxLine={38} />
              </p>
            </div>
          </div>
          {/* {props.caseDetails?.status !== "Review Completed" &&
          props.caseDetails?.status !== "In Review" &&
          props.caseDetails?.status !== "LOI" &&
          props.caseDetails?.status !== "Awaiting Review" ? ( */}
          
          <div className="headingRight">
          {props.caseDetails?.status !== "SUBMITTED" &&
            props.caseDetails?.status !== "ARCHIVED" &&
            props.caseDetails?.status !== "READY_FOR_REVIEW" ?
            <p className="editButtonText">
              <button
                onClick={() => {
                  toggleShowEditLeadModal();
                }}
                // disabled={roles.isSuperUser(bankUserContext?.bankuserDetails?.roles)}
              >
                Edit <img 
                src={editIcon} 
                alt="edit" />
              </button>
            </p>:''}
            {/* <p className="caseType">SAR</p> */}
          </div>
          {/* ) : (
            <></>
          )} */}
        </div>
        <div className="cardetailsbottomsection">
          <div className="leadstatusmaincard">
            <div className="caseDatesContainer">
              <div className="caseDates">
                <p className="statusDataHeading">
                  Due Date
                </p>
                <p className="statusData">
                  {props?.caseDetails?.dueDate ? transformUTCDateWithoutTime(props?.caseDetails?.dueDate) : '- -'}
                </p>
              </div>
            </div>
          </div>
          <div className="leadstatusmaincard">
            <div className="caseDatesContainer">
              <div className="caseDates">
                <p className="statusDataHeading">
                  Days Remaining
                </p>
                <p className={`statusData ${+props?.caseDetails?.dueDays < 0 ? 'negative' : ''} `}>
                  {getDaysRemaining(props?.caseDetails?.dueDays) || 0} days
                </p>
              </div>
            </div>
          </div>
          <div className="descisioncontainer">
            {(props?.caseDetails?.status === "PRELIMINARY")
            // && (props?.caseDetails?.caseTask.filter((m:any)=>m?.type === "Kick_Off_Task").
            // some((n:any)=>n?.status === "Completed") &&
            // props?.caseDetails?.caseTask.filter((m:any)=>m?.type === "Task").
            // some((n:any)=>n?.status === "Completed"))||
            // (props?.caseDetails?.caseTask.filter((m:any)=>m?.type === "Kick_Off_Task").
            // some((n:any)=>n?.status === "Completed")&&
            // props?.caseDetails?.caseTask.filter((m:any)=>m?.type === "Task").
            // some((n:any)=>n?.status === "Completed")&&
            // props?.caseDetails?.caseTask.filter((m:any)=>m?.type === "Closing_Task").
            // some((n:any)=>n?.status === "Completed") )
            ?
              <button
                className="decisionbutton"
                onClick={() => statusChangeHandler(props?.caseDetails?.caseId)}>
                Submit
              </button> : <></>}
          </div>
        </div>
        {props?.caseDetails?.lor ?
          <div
            className={`expand-btn ${expand ? 'expand' : ''}`}
            onClick={() => caseDetails?.lor && setExpand(!expand)}
          >
            <img 
            src={expand ? slideBackIcon : sideOutArrowIcon} 
            alt="sideOutArrowIcon" />
          </div> : <></>}
      </div>
      {!expand ? <div className="statusContainer">
        {caseSatusDetails?.map((each, index) =>
          <CaseDetailsStatus
            key={index}
            status={each}
            className={`caseStatus ${each?.heading?.toLowerCase()}`}
          />
        )}
      </div> : <></>}
    </div>
  )
}

export default CaseMasterDetails